import { constants, isDisplayable } from "@qgiv/core-js";

const {
    ENUMS: { ItemType, EntityType },
} = constants;

/**
 * @param {object} selectedPlan - The selected plan object.
 * @param {object} defaultRecurringFrequency - The default recurring frequency object.
 * @returns {string} The recurring frequency value.
 */
const getPlanRecurringFrequency = (selectedPlan, defaultRecurringFrequency) => {
    let recurringFrequency;
    const selectedPlanIsCreateYourOwnPlan =
        parseInt(selectedPlan.pledgeType, 10) === ItemType.CREATE_YOUR_OWN;
    if (selectedPlanIsCreateYourOwnPlan) {
        recurringFrequency = defaultRecurringFrequency.value;
    } else {
        recurringFrequency = selectedPlan.frequencyEnum;
    }

    return recurringFrequency;
};

/**
 * @param {object} settings
 * @param {boolean} settings.isSinglePageForm
 * @param {object[]} settings.systemFields
 * @param {object} settings.control
 * @param {number} settings.currentDisplay
 * @param {boolean} settings.isInstallment
 * @param {boolean} settings.enableMatching
 * @returns {boolean} True if the matching gift notice should be displayed, false otherwise.
 */
export const getShouldDisplayMatchingGiftNotice = ({
    isSinglePageForm,
    systemFields,
    control,
    currentDisplay,
    isInstallment,
    enableMatching,
}) => {
    const matchingGiftSystemField =
        systemFields.find(
            (field) =>
                field.type === EntityType.SYSTEM_FIELD_GROUP_MATCHING_GIFTS,
        ) || {};

    const { options = {} } = matchingGiftSystemField;

    const controlOptions = control?.options || {};
    const { displayMatchingGiftNotice = false } = controlOptions;

    const matchingGiftsDisplayedOnDevice =
        Object.keys(options).length > 0 &&
        isDisplayable(options, currentDisplay);

    const shouldDisplayMatchingGiftNotice =
        !isSinglePageForm &&
        displayMatchingGiftNotice &&
        isInstallment &&
        enableMatching &&
        matchingGiftsDisplayedOnDevice;

    return shouldDisplayMatchingGiftNotice;
};

export { getPlanRecurringFrequency };
